import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ExperimentCreatePage } from '@/features/ml/experiments/experiment-create-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Nouvelle expérience (porting README #80). Segment statique : gagne sur `$experimentId`. */
export const Route = createFileRoute('/$tenant/projects/$projectId/experiments/new')({
  component: NewExperimentRoute,
});

function NewExperimentRoute() {
  const { tenant, projectId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="experiments"
      crumbs={[{ label: t('nav.items.experiments') }, { label: t('ml.experiments.newTitle') }]}
    >
      <ExperimentCreatePage tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
